import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TenantBrandingContext = createContext(null);
export { TenantBrandingContext };

const isSystemHost = (hostname) => {
  const systemPatterns = [
    'localhost', '127.0.0.1', 'emergentagent.com',
    'stage-preview', 'preview', 'myclientpm.com'
  ];
  return systemPatterns.some((p) => hostname.includes(p));
};

export const TenantBrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(null);
  const [brandingLoading, setBrandingLoading] = useState(true);

  useEffect(() => {
    const detectBranding = async () => {
      try {
        // Option 1: Path-based slug — e.g. myclientpm.com/nmnetwork
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const slug = pathParts[0]; // first segment, e.g. "nmnetwork"

        // Option 2: Subdomain-based (future use)
        const hostname = window.location.hostname.toLowerCase();
        const isSystem = isSystemHost(hostname);

        let res = null;

        // Reserved app routes — never treat these as tenant portal slugs
        const RESERVED_PATHS = new Set([
          'login','dashboard','reset-password','projects','clients','tenants',
          'calendar','meetings','seo','invoices','billing','users','profile',
          'my-settings','forms','settings','and-go'
        ]);

        // Try slug first (path-based)
        if (slug && !RESERVED_PATHS.has(slug)) {
          try {
            res = await axios.get(`${API_URL}/tenant/branding?slug=${encodeURIComponent(slug)}`);
          } catch {
            res = null;
          }
        }

        // Fall back to domain-based if not on system host
        if (!res && !isSystem) {
          try {
            res = await axios.get(`${API_URL}/tenant/branding?domain=${encodeURIComponent(hostname)}`);
          } catch {
            res = null;
          }
        }

        if (res?.data?.id) {
          setBranding({ ...res.data, slug });
        }
      } catch {
        setBranding(null);
      } finally {
        setBrandingLoading(false);
      }
    };

    detectBranding();
  }, []);

  return (
    <TenantBrandingContext.Provider value={{ branding, brandingLoading }}>
      {children}
    </TenantBrandingContext.Provider>
  );
};

export const useTenantBranding = () => useContext(TenantBrandingContext);
